/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Refreshqueued1Inputs */

const id_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ditambahkan ke antrean untuk disegarkan, akan segera diperbarui.`)
};

const ms_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ditambah ke baris gilir untuk disegarkan, ia akan dikemas kini tidak lama lagi.`)
};

const da_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tilføjet til opdateringskø, den vil blive opdateret snart.`)
};

const de_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil zur Aktualisierung in die Warteschlange gestellt, es wird bald aktualisiert.`)
};

const en_us2_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile added to queue for refresh, it will be updated soon.`)
};

const es_es2_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil añadido a la cola para actualización, se actualizará pronto.`)
};

const es_mx2_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil agregado a la cola para actualización, se actualizará pronto.`)
};

const fil_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idinagdag ang profile sa queue para sa refresh, malapit na itong ma-update.`)
};

const fr_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ajouté à la file d'attente d'actualisation, il sera bientôt mis à jour.`)
};

const it_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo aggiunto alla coda per l'aggiornamento, verrà aggiornato a breve.`)
};

const hu_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil hozzáadva a frissítési sorhoz, hamarosan frissülni fog.`)
};

const nl_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel toegevoegd aan wachtrij voor vernieuwing, het wordt binnenkort bijgewerkt.`)
};

const no_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil lagt til i kø for oppdatering, den vil bli oppdatert snart.`)
};

const pl_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil dodany do kolejki odświeżania, zostanie wkrótce zaktualizowany.`)
};

const pt_br2_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil adicionado à fila para atualização, será atualizado em breve.`)
};

const pt_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil adicionado à fila para atualização, será atualizado em breve.`)
};

const ro_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil adăugat în coadă pentru reîmprospătare, va fi actualizat în curând.`)
};

const fi_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiili lisätty päivitysjonoon, se päivitetään pian.`)
};

const sv_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil tillagd i kön för uppdatering, den kommer att uppdateras snart.`)
};

const vi_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ đã được thêm vào hàng đợi làm mới, sẽ được cập nhật sớm.`)
};

const tr_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil yenileme kuyruğuna eklendi, yakında güncellenecek.`)
};

const cs_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil přidán do fronty na obnovení, bude brzy aktualizován.`)
};

const bg_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профилът е добавен в опашката за опресняване, ще бъде актуализиран скоро.`)
};

const ru_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль добавлен в очередь обновления, скоро будет обновлён.`)
};

const uk_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профіль додано до черги на оновлення — незабаром він буде оновлений.`)
};

const ar_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمت إضافة الملف الشخصي إلى قائمة الانتظار للتحديث، وسيتم تحديثه قريبًا.`)
};

const hi_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल रिफ्रेश के लिए कतार में जोड़ दी गई है, जल्द ही अपडेट हो जाएगी।`)
};

const th_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มโปรไฟล์ในคิวสำหรับรีเฟรช แล้วจะได้รับการอัปเดตเร็ว ๆ นี้`)
};

const ja_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールが更新キューに追加されました。まもなく更新されます。`)
};

const zh_cn2_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料已加入刷新队列，即将更新。`)
};

const zh_hant1_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人資料已加入重新整理佇列，即將更新。`)
};

const ko_profile_errors_refreshqueued1 = /** @type {(inputs: Profile_Errors_Refreshqueued1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필이 새로고침 대기열에 추가되었습니다. 곧 업데이트됩니다.`)
};

/**
* | output |
* | --- |
* | "Profile added to queue for refresh, it will be updated soon." |
*
* @param {Profile_Errors_Refreshqueued1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_errors_refreshqueued1 = /** @type {((inputs?: Profile_Errors_Refreshqueued1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Refreshqueued1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_errors_refreshqueued1(inputs)
	if (locale === "ms") return ms_profile_errors_refreshqueued1(inputs)
	if (locale === "da") return da_profile_errors_refreshqueued1(inputs)
	if (locale === "de") return de_profile_errors_refreshqueued1(inputs)
	if (locale === "en-US") return en_us2_profile_errors_refreshqueued1(inputs)
	if (locale === "es-ES") return es_es2_profile_errors_refreshqueued1(inputs)
	if (locale === "es-MX") return es_mx2_profile_errors_refreshqueued1(inputs)
	if (locale === "fil") return fil_profile_errors_refreshqueued1(inputs)
	if (locale === "fr") return fr_profile_errors_refreshqueued1(inputs)
	if (locale === "it") return it_profile_errors_refreshqueued1(inputs)
	if (locale === "hu") return hu_profile_errors_refreshqueued1(inputs)
	if (locale === "nl") return nl_profile_errors_refreshqueued1(inputs)
	if (locale === "no") return no_profile_errors_refreshqueued1(inputs)
	if (locale === "pl") return pl_profile_errors_refreshqueued1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_errors_refreshqueued1(inputs)
	if (locale === "pt") return pt_profile_errors_refreshqueued1(inputs)
	if (locale === "ro") return ro_profile_errors_refreshqueued1(inputs)
	if (locale === "fi") return fi_profile_errors_refreshqueued1(inputs)
	if (locale === "sv") return sv_profile_errors_refreshqueued1(inputs)
	if (locale === "vi") return vi_profile_errors_refreshqueued1(inputs)
	if (locale === "tr") return tr_profile_errors_refreshqueued1(inputs)
	if (locale === "cs") return cs_profile_errors_refreshqueued1(inputs)
	if (locale === "bg") return bg_profile_errors_refreshqueued1(inputs)
	if (locale === "ru") return ru_profile_errors_refreshqueued1(inputs)
	if (locale === "uk") return uk_profile_errors_refreshqueued1(inputs)
	if (locale === "ar") return ar_profile_errors_refreshqueued1(inputs)
	if (locale === "hi") return hi_profile_errors_refreshqueued1(inputs)
	if (locale === "th") return th_profile_errors_refreshqueued1(inputs)
	if (locale === "ja") return ja_profile_errors_refreshqueued1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_errors_refreshqueued1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_errors_refreshqueued1(inputs)
	return ko_profile_errors_refreshqueued1(inputs)
});
export { profile_errors_refreshqueued1 as "profile.errors.refreshQueued" }